﻿class archdatadiff extends Tango.Component {
	widgetDidMount() {
		const savebtn = document.getElementById("info_ti_replacearchcomm_savebtn");
		var _this = this;
		if (savebtn)
			savebtn.addEventListener("click", function () {
				document.querySelector("input[name='diff']").value = encodeURIComponent(JSON.stringify(_this.state.diff));
			});
		document.querySelectorAll("a[data-openDialog]").forEach(function (a) {
			var arg = a.getAttribute('data-openDialog');
			a.addEventListener("click", function () {
				_this.openDialog(arg = '' ? null : arg);
			});
		});
		document.querySelectorAll("a[data-clear]").forEach(function (a) {
			var arg = a.getAttribute('data-clear');
			a.addEventListener("click", function () {
				_this.clear(arg = '' ? null : arg);
			});
		});
	}
	openDialog(field) {
		if (field == null && document.querySelectorAll("input.type-reason[data-drl='2']:checked").length == 0) {
			alert('Не выбраны получасовки для установки причины');
			return;
		}
		const sd = document.getElementById(this.props.selectDialogID);
		if (window.innerWidth > 800)
			sd.style.width = window.innerWidth - 500 + 'px';
		else
			sd.style.width = 500 + 'px';
		dialog.open(sd);
		//if (document.getElementById("info_ti_replacearchcomm_data").offsetWidth < (window.innerWidth - sd.offsetWidth)) {
		//	sd.style.left = (document.getElementById("info_ti_replacearchcomm_data").offsetWidth + 10).toString() + 'px';
		//	sd.style.marginLeft = "0px";
		//}
		sd.querySelectorAll("tr[data-reasonid] a").forEach(function (a) {
			a.onclick = function () {
				const isCollapsed = this.firstChild.classList.contains('icon-collapsed');
				if (isCollapsed) {
					this.childNodes[0].classList.remove('icon-collapsed');
					this.childNodes[0].classList.add('icon-expanded');
					sd.querySelectorAll("tr[data-reasonid='" + this.parentElement.parentElement.getAttribute('data-reasonid') + "'][data-caseid]").forEach(function (el) {
						el.classList.remove('hide');
					});
				}
				else {
					this.childNodes[0].classList.add('icon-collapsed');
					this.childNodes[0].classList.remove('icon-expanded');
					sd.querySelectorAll("tr[data-reasonid='" + this.parentElement.parentElement.getAttribute('data-reasonid') + "'][data-caseid]").forEach(function (el) {
						el.classList.add('hide');
					});
				}
			}
		});
		var _this = this;
		sd.querySelectorAll(".archdatareasoncaseicon").forEach(function (div) {
			const td = div.parentElement;
			const tr = td.parentElement;
			td.onclick = function () {
				var caseid = tr.getAttribute("data-caseid");
				var reasonid = tr.getAttribute("data-reasonid");
				var casename = tr.getAttribute("data-case");
				var reasonname = tr.getAttribute("data-reason");
				var caseNumber = div.innerHTML;
				var reasonNumber = div.getAttribute("data-reasonnumber");

				var names = [];
				if (field == null) {
					document.querySelectorAll(":not(.cantsetreason) input.type-reason[data-drl='2']:checked").forEach(function (el) {
						const tr = el.parentNode.parentNode;
						if (tr.classList.contains('cantsetreason'))
							return;
						var name = el.getAttribute("name");
						name = name.substring(0, name.length - 3);
						names.push(name);
					});
				}
				else {
					names.push(field);
				}
				names.forEach(function (name) {
					if (!_this.state.diff[name])
						_this.state.diff[name] = {};
					_this.state.diff[name].archDataDiffReason_ID = reasonid;
					_this.state.diff[name].archDataDiffReasonNumber = reasonNumber;
					_this.state.diff[name].archDataDiffReasonCase_ID = caseid;
					_this.state.diff[name].archDataDiffReasonCaseNumber = caseNumber;

					var col_r = document.querySelector("div[data-id='" + name + "_r']");
					col_r.innerHTML = _this.state.diff[name].archDataDiffReasonNumber;
					col_r.classList.remove("hide");
					col_r.setAttribute("title", reasonname);

					while (col_r.classList.length > 0) {
						col_r.classList.remove(col_r.classList.item(0));
					}
					//col_r.classList.remove("archdatareasoncol_" + col_r.innerHTML);
					col_r.classList.add("archdatareasoncol");
					col_r.classList.add("archdatareasoncol_" + _this.state.diff[name].archDataDiffReasonNumber);

					var col_c = document.querySelector("div[data-id='" + name + "']");
					col_c.innerHTML = _this.state.diff[name].archDataDiffReasonCaseNumber;
					col_c.classList.remove("hide");
					col_c.setAttribute("title", casename);
					var del = document.querySelector("a[data-clear='" + name + "']");
					del.classList.remove("hide");
				});
				dialog.close(sd);
			};
		});

		return false;
	}
	clear(field) {

		if (field == null && document.querySelectorAll("input.type-reason[data-drl='2']:checked").length == 0) {
			alert('Не выбраны получасовки для снятия причины');
			return;
		}

		var names = [];
		if (field == null) {
			document.querySelectorAll("input.type-reason[data-drl='2']:checked").forEach(function (el) {
				var name = el.getAttribute("name");
				name = name.substring(0, name.length - 3);
				names.push(name);
			});
		}
		else {
			names.push(field);
		}
		var _this = this;
		names.forEach(function (name) {
			if (_this.state.diff[name]) {
				_this.state.diff[name].archDataDiffReasonCase_ID = 0;
				_this.state.diff[name].archDataDiffReason_ID = 0;
			}

			var col_r = document.querySelector("div[data-id='" + name + "_r']");
			col_r.classList.add("hide");
			var col_c = document.querySelector("div[data-id='" + name + "']");
			col_c.classList.add("hide");
			var del = document.querySelector("a[data-clear='" + name + "']");
			del.classList.add("hide");
		});
	}
};

Tango.registerComponent(archdatadiff, sp => ({
	cu: sp.commonUtils,
	au: sp.ajaxUtils,
	moment: moment,
	btnSwitchCtor: id => sp.components.btnswitch(id, sp)
}));